import dayjs from "dayjs";
import type { DanmakuItem, DanmakuPoolItem } from "./constants";
import {
  DANMAKU_AVATARS,
  DANMAKU_VISIBLE_COUNT,
  LIVE_SHARE_DESIGN_WIDTH,
} from "./constants";

const win: any = window;

const screenWidth = window.screen.width;
const calcLiveShareRatio = (size: number) =>
  (size * screenWidth) / LIVE_SHARE_DESIGN_WIDTH;

/** 背景日期文案：设计稿 left 240 / top 306 / font 13（与 fifaGetCoupon RATIOS 同一套换算） */
export const LIVE_SHARE_DATE_LABEL_LAYOUT = {
  left: calcLiveShareRatio(245),
  top: calcLiveShareRatio(247),
  fontSize: calcLiveShareRatio(13),
};

/** 当前日期，如 4月15日（与红包页 Top 展示习惯一致，无前导零） */
export const formatLiveShareCurrentDate = () => dayjs().format("M月D日");

export const getPageSourceFromRouter = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const pageSource = searchParams.get("page_source") || "";
  return pageSource;
};

export const goTrick = (btnName = "打开看看") => {
  win?.sensors?.track("buttonClick", {
    belong_page: "2026FIFA直播间分享H5页",
    page_source: getPageSourceFromRouter(),
    button_name: btnName,
  });
};

/** 从 4 个头像下标 [0, avatarCount) 中不重复随机取 count 个 */
export const pickRandomAvatarIndices = (
  count: number,
  avatarCount = DANMAKU_AVATARS.length
): number[] => {
  const max = Math.min(count, avatarCount);
  const picked: number[] = [];
  const usedIndex = new Set<number>();

  while (picked.length < max) {
    const idx = Math.floor(Math.random() * avatarCount);
    if (usedIndex.has(idx)) continue;
    usedIndex.add(idx);
    picked.push(idx);
  }
  return picked;
};

/** 从弹幕池随机取 count 条（不重复下标），并为每条随机分配头像 */
export const pickRandomDanmaku = (
  pool: DanmakuPoolItem[],
  count = DANMAKU_VISIBLE_COUNT
): DanmakuItem[] => {
  if (!pool.length) return [];
  const max = Math.min(count, pool.length);
  const picked: DanmakuPoolItem[] = [];
  const usedIndex = new Set<number>();

  while (picked.length < max) {
    const idx = Math.floor(Math.random() * pool.length);
    if (usedIndex.has(idx)) continue;
    usedIndex.add(idx);
    picked.push(pool[idx]);
  }

  const avatarIndices = pickRandomAvatarIndices(picked.length);
  return picked.map((item, i) => ({
    ...item,
    avatar: DANMAKU_AVATARS[avatarIndices[i]],
  }));
};
